<div class="table-responsive rounded border" style="background: #ffffff; border-color: #e2e8f0 !important;" *ngIf="attachedDocumentsList?.length">
  <table class="table table-hover table-striped mb-0" style="font-size: 0.8125rem;">
    <thead style="background: var(--theme-primary, #123c53); color: #ffffff;">
      <tr>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Category</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Type</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Doc Type</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Doc Title</th>
        <th class="py-2 text-uppercase font-weight-bold text-center" style="font-size: 0.75rem; letter-spacing: 0.5px;">Pages</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Remark</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Upload By</th>
        <th class="py-2 text-uppercase font-weight-bold text-center" style="font-size: 0.75rem; letter-spacing: 0.5px;">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of attachedDocumentsList">
        <td class="font-weight-bold text-dark">{{ row.Category }}</td>
        <td class="text-dark">{{ row.Type }}</td>
        <td class="text-dark">{{ row.DocType }}</td>
        <td class="font-weight-bold text-primary">{{ row.DocTitle }}</td>
        <td class="text-center font-weight-bold text-secondary">{{ row.No_Of_Pages }}</td>
        <td class="text-muted small">{{ row.Remark || '-' }}</td>
        <td class="text-dark">{{ row.UploadBy }}</td>
        <td class="text-center">
          <a
            *ngIf="row.UD_DocFileName"
            href="{{ docBaseUrl }}{{ ApplicationNumber.Application_No }}/{{ row.UD_DocFileName }}"
            target="_blank"
            class="btn btn-sm btn-outline-primary py-0 px-2 font-size-11"
            title="View Document"
          >
            <i class="fas fa-eye mr-1"></i> View
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
